const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001'

export const VIDEO_FORMATS = [
  { key: 'mp4', label: 'MP4' },
  { key: 'webm', label: 'WebM' },
  { key: 'mov', label: 'MOV' },
  { key: 'avi', label: 'AVI' },
  { key: 'mkv', label: 'MKV' },
]

export const AUDIO_FORMATS = [
  { key: 'mp3', label: 'MP3' },
  { key: 'wav', label: 'WAV' },
  { key: 'ogg', label: 'OGG' },
  { key: 'm4a', label: 'M4A' },
  { key: 'flac', label: 'FLAC' },
]

export const convertMediaFile = async (file, targetFormat) => {
  const formData = new FormData()
  formData.append('targetFormat', targetFormat)
  formData.append('file', file)

  const response = await fetch(`${API_URL}/api/convert-media`, {
    method: 'POST',
    body: formData,
  })
  if (!response.ok) {
    const data = await response.json().catch(() => ({}))
    throw new Error(data.message || 'Não foi possível converter esse arquivo agora.')
  }
  return response.blob()
}
